import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.join";
import "core-js/modules/es.array.map";
import "core-js/modules/es.function.name";
import "core-js/modules/es.number.to-fixed";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/web.dom-collections.for-each";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { tabulation } from "@/mixins/index";
import channelComMixins from "./mixins/channelComMixins";
import { hourlySummary, hourlySummary_currency } from "@/api/dataPirate/channelData";
import * as echarts from "echarts";
export default {
  name: 'collect',
  mixins: [tabulation, channelComMixins],
  data: function data() {
    return {
      name: 'collect'
    };
  },
  created: function created() {
    this.$DBControls.initPage(this.name);
  },
  mounted: function mounted() {},
  methods: {
    getDate: function getDate() {
      var now = new Date(this.$times.zeroTimeZone());
      var year = now.getFullYear();
      var month = (now.getMonth() + 1).toString().length < 2 ? "0" + (now.getMonth() + 1) : now.getMonth() + 1;
      var date = now.getDate().toString().length < 2 ? "0" + now.getDate() : now.getDate();
      var date = year + "-" + month + "-" + date;
      this.searchData.date = date;
    },

    /**
     * 整点汇总 star
     */
    searchClick: function searchClick() {
      var _this = this;

      var isverification = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      // if(this.currencyClose && !this.searchData.currency_info){
      //   if(isverification){
      //     this.$message.error('请选择货币类型')
      //   }  
      //   return
      // }
      this.$DBControls.get(this.name, this.searchData.date).then( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dbres) {
          var reqFn, queryData;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (!dbres.content.length) {
                    _context.next = 3;
                    break;
                  }

                  _context.next = 9;
                  break;

                case 3:
                  _this.reqLoading = true;
                  reqFn = _this.currencyClose ? hourlySummary_currency : hourlySummary;
                  _context.next = 7;
                  return reqFn(_objectSpread(_objectSpread({}, _this.searchData), _this.defaultData()));

                case 7:
                  queryData = _context.sent;
                  reqFn(_objectSpread(_objectSpread({}, _this.searchData), _this.defaultData())).then(function (res) {
                    if (res.code == 200) {
                      _this.$DBControls.add(_this.name, _this.searchData.date, res.data);

                      _this.tableData = [];

                      var objToKey = function objToKey(obj) {
                        return Object.keys(obj).map(function (k) {
                          return k;
                        });
                      };

                      var tarr = objToKey(res.data);
                      tarr.sort();
                      tarr.forEach(function (i, index) {
                        var h = index;
                        var h1 = index + 1;

                        _this.processingList.forEach(function (item) {
                          res.data[i][item] = _this.$utils.conversion(res.data[i][item]).toFixed(2);
                        });

                        var data = _objectSpread({
                          hours: (h < 10 ? '0' + h : h) + ':00 ~ ' + (h1 < 10 ? '0' + h1 : h1) + ':00'
                        }, res.data[i]);

                        _this.tableData.push(data);
                      });

                      _this.getescreenChart();
                    }
                  }).finally(function () {
                    _this.reqLoading = false;
                  });

                case 9:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    getescreenChart: function getescreenChart() {
      var _this2 = this;

      var chartDom = document.getElementById("echartcollect");

      if (this.echartcollect != null && this.echartcollect != "" && this.echartcollect != undefined) {
        this.echartcollect.dispose(); //销毁
      }

      this.echartcollect = echarts.init(chartDom);
      var data = [];
      var series = [];
      this.tableData.forEach(function (item) {
        data.push(item.hours);
      });
      this.screenList.forEach(function (item, index) {
        series.push({
          name: item.label,
          type: "line",
          data: _this2.tableData.map(function (i) {
            return i[item.prop];
          }),
          smooth: true,
          symbol: "none"
        });
      });
      var option;
      option = {
        animationDuration: 3000,
        tooltip: {
          trigger: "axis",
          confine: true
        },
        legend: {
          width: '100%',
          icon: 'circle',
          itemHeight: 12,
          bottom: '0%',
          itemWidth: 15,
          inactiveColor: '#666666',
          formatter: ['{a|{name}}'].join('\n'),
          textStyle: {
            fontSize: 12,
            lineHeight: 12,
            rich: {
              a: {
                width: 120,
                verticalAlign: 'middle'
              }
            },
            padding: [0, 0, -2, -4] //[上、右、下、左]

          },
          selected: this.screenselected
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "18%",
          containLabel: true
        },
        toolbox: {
          z: 12,
          feature: {
            saveAsImage: {}
          }
        },
        xAxis: {
          type: "category",
          axisTick: {
            show: false
          },
          data: data
        },
        yAxis: [{
          type: "value",
          splitLine: {
            lineStyle: {
              type: "dashed"
            }
          },
          splitNumber: 5,
          axisLabel: {
            formatter: function formatter(value, index) {
              if (value >= 10000) {
                return (value / 10000).toFixed(2) + "万";
              } else if (value >= 1000) {
                return value;
              } else {
                return value;
              }
            }
          }
        }, {
          type: "value",
          splitNumber: 5,
          axisLabel: {
            formatter: function formatter(value, index) {
              if (value >= 10000) {
                return (value / 10000).toFixed(2) + "万";
              } else if (value >= 1000) {
                return value;
              } else {
                return value;
              }
            }
          }
        }],
        series: series
      };
      option && this.echartcollect.setOption(option, true);
      var that = this;
      this.echartcollect.on('legendselectchanged', function (params) {
        that.screenselected = JSON.parse(JSON.stringify(params.selected));
      });
    }
    /**
    * 整点汇总 end
    */

  }
};